import "../../../../../css/FinancialPromotions/Components/UploadedFileList.css";
import { ReactComponent as RemoveIcon } from "../../../../../assets/icons/financialPromotions/Close.svg";

const UploadedFileList = ({ files = [], onRemove }) => {
  return (
    <div className="ds-uploaded-list">
      {files.map((file, index) => (
        <div
          key={`${file.name}-${file.size}-${index}`}
          className="ds-uploaded-chip"
        >
          {file.url ? (
            <a
              href={file.url}
              target="_blank"
              rel="noopener noreferrer"
              className="Content ds-uploaded-name"
              style={{
                textDecoration: "none",
                color: "inherit",
                cursor: "pointer",
              }}
            >
              {file.name}
            </a>
          ) : (
            <span className="FP_Content ds-uploaded-name">{file.name}</span>
          )}

          <button
            type="button"
            className="ds-uploaded-remove"
            onClick={() => onRemove?.(file, index)}
            aria-label={`Remove ${file.name}`}
          >
            <RemoveIcon />
          </button>
        </div>
      ))}
    </div>
  );
};

export default UploadedFileList;
